//
//
//
//
//
//
//
//
//
//

import {Portal} from "portal-vue";
import {disableWindowScroll, enableWindowScroll, shakeElement} from "../../helpers/html_helpers";
import Toggleable from "../../mixins/Toggleable";

export default {
    name: 'Popup',

    components: {Portal},

    mixins: [Toggleable],

    props: {

        // Whether the popup shall be put as highest z-index position if multiple popups and popovers are displayed at the same time
        highestOrder: {
            type: Boolean,
            default: false
        },

        // The order number of the popup if multiple popups are displayed at the same time
        // Is equal to a CSS 'z-index'
        order: {
            type: Number,
            default: null
        },

        // Whether to not allow a closing of the popup by clicking on the overlay background
        persistent: {
            type: Boolean,
            default: false
        },

        // Whether a zoom transition shall be used for opening the popup and for closing via the overlay background
        zoomTransition: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        openTransitionClass() {
            return this.zoomTransition ? 'popup-enter-active-zoom' : 'popup-enter-active';
        }  ,

        closeTransitionClass() {
            return this.zoomTransition ? 'popup-leave-active-zoom' : 'popup-leave-active';
        }
    },

    watch: {
        isActive(active) {
            if (active) {
                disableWindowScroll();
            } else {
                enableWindowScroll();
            }
        }
    },

    beforeDestroy() {
        enableWindowScroll();
        this.isActive = false;
    },

    methods: {
        handleOverlayClick() {
            if (this.persistent) {
                shakeElement(this.$slots.default[0].elm);
            } else {
                this.close();
            }
        },

        close() {
            this.isActive = false
            this.$emit('closed');
        }
    }
}
